import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import AuthLayout from './layouts/AuthLayout';
import AppLayout from './layouts/AppLayout';
import AuthGuard from './guards/AuthGuard';
import AdminGuard from './guards/AdminGuard';

// Landing + Auth pages
import LandingPage from '../pages/LandingPage';
import LoginPage from '../pages/auth/LoginPage';
import SignupPage from '../pages/auth/SignupPage';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';
import EmailVerificationPage from '../pages/auth/EmailVerificationPage';

// Main pages
import RadioPage from '../pages/radio/RadioPage';
import NearbyPage from '../pages/nearby/NearbyPage';
import DMListPage from '../pages/dm/DMListPage';
import BoardListPage from '../pages/board/BoardListPage';
import BoardDetailPage from '../pages/board/BoardDetailPage';
import BoardWritePage from '../pages/board/BoardWritePage';
import ProfilePage from '../pages/profile/ProfilePage';
import ReportHistoryPage from '../pages/profile/ReportHistoryPage';
import SettingsPage from '../pages/settings/SettingsPage';
import AdminPage from '../pages/admin/AdminPage';

export const router = createBrowserRouter([
  // Landing page (web only) — native apps go straight to login
  { path: '/', element: Capacitor.isNativePlatform() ? <Navigate to="/login" replace /> : <LandingPage /> },
  {
    element: <AuthLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/signup', element: <SignupPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
      { path: '/verify-email', element: <EmailVerificationPage /> },
    ],
  },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: '/app', element: <RadioPage /> },
          { path: '/nearby', element: <NearbyPage /> },
          { path: '/dm', element: <DMListPage /> },
          { path: '/board', element: <BoardListPage /> },
          { path: '/board/:postId', element: <BoardDetailPage /> },
          { path: '/board/write', element: <BoardWritePage /> },
          { path: '/profile', element: <ProfilePage /> },
          { path: '/reports', element: <ReportHistoryPage /> },
          { path: '/settings', element: <SettingsPage /> },
          {
            element: <AdminGuard />,
            children: [{ path: '/admin', element: <AdminPage /> }],
          },
        ],
      },
    ],
  },
]);
